<script setup>
import AppCard from '../components/layouts/AppCard.vue';
import ChildCard from '../components/ChildCard.vue';
import buttonContracts from '~/assets/icon_contracts.svg'
import buttonPuzzle from '~/assets/button_puzzle.svg'
import buttonCalendar from '~/assets/button_calendar.svg'
import { useAuthStore, useAppStore } from '../stores';
import { useRouter } from 'vue-router'

const router = useRouter()
const detailView = true

const authStore = useAuthStore();
</script>

<template>
    <div class="mx-2">
        <div class="grid grid-cols-1 md:grid-cols-3 justify-center content-start">
            <AppCard header="Your Children"
                body="Add your children's profiles to track their growth and milestones. View personalized development indicators and receive recommendations for each child."
                to="/resources/guides">
                <div class="flex flex-row">
                    <img :class="`w-10 h-10 justify-self-end cursor-pointer ${detailView ? 'ml-1' : 'mx-1'}`" v-if="useAppStore.showContracts"
                        aria-hidden="true" @click="router.push('/contracts')" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 20 20" :src="buttonContracts" />
                    <img :class="`w-10 h-10 justify-self-end cursor-pointer ${detailView ? 'ml-1' : 'mx-1'}`"
                        aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"
                        :src="buttonPuzzle" @click="router.push('/resources')" />
                    <img :class="`w-10 h-10 justify-self-end cursor-pointer ${detailView ? 'ml-1' : 'mx-1'}`"
                        aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"
                        :src="buttonCalendar" @click="router.push('/calendar')" />
                </div>
            </AppCard>
            <ChildCard v-for="child in authStore.sortedChildren" :key="child.id" :child="child" />
        </div>
    </div>
</template>